import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "tokens"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { m } from 'framer-motion';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import * as views from './Testimonial.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var BaseTestimonial = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens,
      rest = _objectWithoutProperties(_ref, _excluded);

  var animationState = {
    initial: {
      position: "relative",
      opacity: 0
    },
    animate: {
      opacity: 1,
      transition: {
        duration: 0.75
      }
    },
    exit: {
      position: "absolute",
      top: 0,
      opacity: 0,
      transition: {
        duration: 0.2
      }
    }
  };
  return _jsx(m.div, _objectSpread(_objectSpread({}, animationState), {}, {
    children: _jsx(views.TestimonialWrapper, _objectSpread(_objectSpread(_objectSpread({
      elevation: 3,
      ref: ref
    }, tokens), rest), {}, {
      children: children
    }))
  }));
});
export var Testimonial = withDesignTokens(BaseTestimonial, function (_ref2, theme) {
  var _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? "base" : _ref2$variant;
  return _objectSpread({
    borderRadius: "20px 20px 100px 20px"
  }, variant === "extended" && {
    borderRadius: "20px",
    background: theme.palette.neutrals.white[100],
    display: "grid",
    desktopGridTemplateColumns: "60% 40%"
  });
}, {
  light: function light() {
    return {};
  },
  dark: function dark() {
    return {};
  },
  twilioLight: function twilioLight() {
    return {};
  },
  twilioDark: function twilioDark() {
    return {};
  }
});